/* eslint-disable react/prop-types */
import { useRouteScroll } from '../lib/scroll'

// Shared page shell. Route changes are a clean cut, like turning an album page.
const Page = ({ children }) => {
  useRouteScroll()

  return (
    <main id='main' tabIndex={-1}>
      {children}
    </main>
  )
}

export default Page
